import React from 'react';
import Reveal from './Reveal';
import SectionHead from './SectionHead';
import { clientGroups } from '../data/site';

const ClientGroups = ({ alt = false }) => (
  <section className={`section ${alt ? 'section-alt' : ''}`}>
    <div className="container">
      <SectionHead
        eyebrow="Our clients"
        title="Institutes and organisations we work with"
      />
      <div className="client-groups">
        {clientGroups.map((group, index) => (
          <Reveal key={group.title} className="client-group" delay={index * 0.06}>
            <h3>{group.title}</h3>
            <p>{group.text}</p>
            <ul className="tag-list">
              {group.clients.map((client) => (
                <li key={client}>{client}</li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ClientGroups;
